import { ONBOARDING_FOUNDATIONS } from '../../constants/ApiNames';
export const isOnboardingFoundationSku = ({
  skuMap,
  skuId
}) => {
  const sku = skuMap[skuId];
  return sku.productApiName === ONBOARDING_FOUNDATIONS;
};